"use client";
import TalkToExperts from "@/components/homepage/TalkToExperts";
import { useAuth } from "@/hook/useAuth";
import Image from "next/image";
import React, { useEffect, useState } from "react";

const NoRecordsFound = ({
	isAiCourseFinder,
}: {
	isAiCourseFinder?: boolean;
}) => {
	const { isAnonymous } = useAuth();

	const [expertForm, setExpertForm] = useState(false);
	const [currentStep, setCurrentStep] = useState(1);

	const expertFromHandler = () => {
		setExpertForm(true);
		document.body.classList.add("overflow-hidden");
	};

	useEffect(() => {
		setCurrentStep(isAnonymous ? 1 : 2);
	}, [expertForm, isAnonymous]);

	return (
		<>
			{isAiCourseFinder ? (
				<>
					<div className="h-full w-full flex items-center justify-center flex-col pb-4 3xl:pb-5 px-5">
						<Image
							className="max-w-[250px] md:max-w-[350px] 3xl:max-w-[450px]"
							src="/assets/images/png/counselor.png"
							alt="hand-phone"
							width={465}
							height={363}
						/>
						<p className="ff_poppins font-semibold text-base md:text-xl 3xl:text-2xl text-black text-center mb-2 3xl:mb-4">
							No exact matches? No problem!
						</p>
						<p className="ff_poppins text-sm md:text-base 3xl:text-xl text-center max-w-[551px]">
							Our counsellors can match your goals with the perfect study
							options abroad - let’s find your fit!
						</p>
						<div className="flex  items-center justify-center mt-3 sm:mt-5">
							<button
								onClick={expertFromHandler}
								className=" font-semibold cursor-pointer text-white text-base sm:text-lg lg:text-xl 3xl:text-2xl text-center bg-button-gradient ff_poppins leading-6 sm:leading-7 md:leading-8 lg:leading-[34px] xl:leading-[36px] px-8 xl:px-8 py-3 sm:py-4 rounded-xl duration-300 ease-in-out hover:scale-105 mb-2 sm:mb-0 flex items-center relative">
								Book a Session Now
							</button>
						</div>
					</div>
				</>
			) : (
				<div className="h-full w-full flex items-center justify-center flex-col py-8 px-5">
					{/* Icon container */}
					<div
						className="w-[72px] h-[72px] rounded-[36px] flex items-center justify-center mb-6"
						style={{
							background: "#EFF4FF",
							border: "1px solid #E5E7EB",
							boxShadow: "0px 1px 3px 0px #0000001A, 0px 1px 2px -1px #0000001A",
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="w-8 h-8"
							viewBox="0 0 24 24"
							fill="none"
							stroke="#1776F0"
							strokeWidth={2}
							strokeLinecap="round"
							strokeLinejoin="round"
						>
							<circle cx="11" cy="11" r="8" />
							<path d="m21 21-4.3-4.3" />
						</svg>
					</div>

					{/* Heading */}
					<p
						className="ff_poppins text-center"
						style={{
							fontWeight: 600,
							fontSize: "16px",
							lineHeight: "24px",
							color: "#1A1A1A",
						}}
					>
						Nothing matched this time…
					</p>

					{/* Subheading */}
					<p
						className="ff_poppins text-center mt-1"
						style={{
							fontWeight: 400,
							fontSize: "14px",
							lineHeight: "20px",
							color: "#6A7282",
						}}
					>
						keep typing and exploring—you&apos;ll find the right fit soon!
					</p>
				</div>
			)}
			{expertForm && (
				<TalkToExperts
					expertForm={expertForm}
					setExpertForm={setExpertForm}
					currentStep={currentStep}
					setCurrentStep={setCurrentStep}
				/>
			)}
		</>
	);
};

export default NoRecordsFound;
